import React from 'react'
import {
  Button,
  Card,
  Grid,
  Image,
} from 'semantic-ui-react'
import product1 from '../../../images/product.1.png'
import product2 from '../../../images/product.2.png'
import product3 from '../../../images/product.3.png'

const rowData = {
  1: {
    type: 'rowAddon',
    value: {
      name: 'First item',
      columns: [{
        weight: 12,
        modules: [
          {
            'type': 'image',
            'src': 'https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/BeeDemo002/2fdfc2a9-b26e-4eb2-a5f8-54ab44b2594c/waterbottle.png',
            'href': 'https://www.beefree.io',
            'alt': 'Water bottle',
            'dynamicSrc': ''
          },
          {
            type: 'title',
            text: 'Water Bottle'
          },
          {
            type: 'paragraph',
            text: 'A sustainable water bottle that uses innovative technology to allow people to access pristine drinking wayter easily and sustainably.'
          }, {
            'type': 'button',
            'text': 'Buy Now',
            'href': 'https://lipsum.com',
          }
        ]
      }]
    }
  },
  2: {
    type: 'rowAddon',
    value: {
      name: 'First item',
      columns: [
        {
          weight: 6,
          modules: [
            {
              'type': 'image',
              'src': 'https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/BeeDemo002/2fdfc2a9-b26e-4eb2-a5f8-54ab44b2594c/waterbottle.png',
              'href': 'https://www.beefree.io',
              'alt': 'Water bottle',
              'dynamicSrc': ''
            },
            {
              type: 'title',
              text: 'Water Bottle'
            },
            {
              type: 'paragraph',
              text: 'A sustainable water bottle that uses innovative technology to allow people to access pristine drinking wayter easily and sustainably.'
            }, {
              'type': 'button',
              'text': 'Buy Now',
              'href': 'https://lipsum.com',
            }
          ]
        },
        {
          weight: 6,
          modules: [
            {
              'type': 'image',
              'src': 'https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/BeeDemo002/2fdfc2a9-b26e-4eb2-a5f8-54ab44b2594c/shoppingbag.png',
              'href': 'https://www.beefree.io',
              'alt': 'Shopping Bag',
              'dynamicSrc': ''
            },
            {
              type: 'title',
              text: 'Shopping Bag'
            },
            {
              type: 'paragraph',
              text: 'A convenient reusable large shopping bag is an excellent alternative to paper or plastic.'
            }, {
              'type': 'button',
              'text': 'Buy Now',
              'href': 'https://lipsum.com',
            }
          ]
        }
      ]
    }
  },
  3: {
    type: 'rowAddon',
    value: {
      name: 'First item',
      columns: [
        {
          weight: 4,
          modules: [
            {
              'type': 'image',
              'src': 'https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/BeeDemo002/2fdfc2a9-b26e-4eb2-a5f8-54ab44b2594c/waterbottle.png',
              'href': 'https://www.beefree.io',
              'alt': 'Water bottle',
              'dynamicSrc': ''
            },
            {
              type: 'title',
              text: 'Water Bottle'
            },
            {
              type: 'paragraph',
              text: 'A sustainable water bottle that uses innovative technology to allow people to access pristine drinking wayter easily and sustainably.'
            }, {
              'type': 'button',
              'text': 'Buy Now',
              'href': 'https://lipsum.com',
            }
          ]
        },
        {
          weight: 4,
          modules: [
            {
              'type': 'image',
              'src': 'https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/BeeDemo002/2fdfc2a9-b26e-4eb2-a5f8-54ab44b2594c/shoppingbag.png',
              'href': 'https://www.beefree.io',
              'alt': 'Shopping Bag',
              'dynamicSrc': ''
            },
            {
              type: 'title',
              text: 'Shopping Bag'
            },
            {
              type: 'paragraph',
              text: 'A convenient reusable large shopping bag is an excellent alternative to paper or plastic.'
            }, {
              'type': 'button',
              'text': 'Buy Now',
              'href': 'https://lipsum.com',
            }
          ]
        },
        {
          weight: 4,
          modules: [
            {
              'type': 'image',
              'src': 'https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/BeeDemo002/2fdfc2a9-b26e-4eb2-a5f8-54ab44b2594c/teapot_1.png',
              'href': 'https://www.beefree.io',
              'alt': 'Teapot',
              'dynamicSrc': ''
            },
            {
              type: 'title',
              text: 'Teapot'
            },
            {
              type: 'paragraph',
              text: 'Teapot with a steel filter perfect for teas, herbs, and infusions.'
            }, {
              'type': 'button',
              'text': 'Buy Now',
              'href': 'https://lipsum.com',
            }
          ]
        }
      ]
    }
  }
}

const RowAddon = ({ save, close }) => {
  const [type, setType] = React.useState('')

  const onHandleCompleted = () => {
    let data = {}
    switch (type) {
      case 'product1':
        data = rowData['1']
        break
      case 'product2':
        data = rowData['2']
        break
      case 'product3':
        data = rowData['3']
        break
      default:
        data = rowData['1']
    }

    save({ ...data })
  }

  const onHandleSave = (value) => {
    setType(value)
  }

  const onHandleClose = () => {
    close()
  }


  const PromoAddonActions = () => {
    return (
      <>
        <div
          className="actions"
          style={{ width: '100%', textAlign: 'right', marginTop: '5px' }}
        >
          <Button onClick={onHandleClose}>
            Cancel
          </Button>
          <Button onClick={onHandleCompleted} primary>
            Continue
          </Button>
        </div>
      </>
    )
  }

  return (
    <>
      <div style={{ width: '100%', marginBottom: '25px' }}>
        <div style={{ color: 'black', paddingBottom: '15px' }}>
          Choose a product layout from the list
        </div>
        <Grid verticalAlign='middle' textAlign='center' centered columns="equal">
          <Grid.Row>
            <Grid.Column>
              <div className={type === 'product1' ? 'cd_highlight' : ''}>
                <Card fluid>
                  <Card.Content style={{ cursor: 'pointer', textAlign: 'center' }} onClick={() => onHandleSave('product1')} >
                    <Card.Header>
                      <Image size='small' src={product1} />
                    </Card.Header>
                    <Card.Description>
                      1 Product
                    </Card.Description>
                  </Card.Content>
                </Card>
              </div>
            </Grid.Column>
            <Grid.Column>
              <div className={type === 'product2' ? 'cd_highlight' : ''}>
                <Card fluid>
                  <Card.Content style={{ cursor: 'pointer', textAlign: 'center' }} onClick={() => onHandleSave('product2')} >
                    <Card.Header>
                      <Image size='small' src={product2} />
                    </Card.Header>
                    <Card.Description>
                      2 Products
                    </Card.Description>
                  </Card.Content>
                </Card>
              </div>
            </Grid.Column>
            <Grid.Column>
              <div className={type === 'product3' ? 'cd_highlight' : ''}>
                <Card fluid>
                  <Card.Content style={{ cursor: 'pointer', textAlign: 'center' }} onClick={() => onHandleSave('product3')} >
                    <Card.Header>
                      <Image size='small' src={product3} />
                    </Card.Header>
                    <Card.Description>
                      3 Products
                    </Card.Description>
                  </Card.Content>
                </Card>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
      <PromoAddonActions />
    </>
  )
}

export default RowAddon
